// ─── Angular Imports ───────────────────────────────────────────────────────────
import { Component, DestroyRef, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

// ─── Application Imports ───────────────────────────────────────────────────────
import { IProduct, ProductSearch } from 'src/app/models/products/product';
import { AuthService } from 'src/app/services/auth.service';
import { Permission } from 'src/app/constants/permission.constant';
import { ProductsService } from 'src/app/services/products.service';
import { SignalrService } from 'src/app/services/signalr.service';
import { SignalrGroup } from 'src/app/services/signalr-group';
import { SignalRStaticGroups } from 'src/app/constants/signalr.constant';
import { updateRecentlyList } from 'src/app/utils/recentlyList';

@Component({
    selector: 'app-post-production-reviewed-latest',
    templateUrl: './post-production-reviewed-latest.component.html',
    styleUrls: ['./post-production-reviewed-latest.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class PostProductionReviewedLatestComponent implements OnInit, OnDestroy {
  // ─── State ───────────────────────────────────────────────────────────────────
  private readonly destroyRef = inject(DestroyRef);
  Permission = Permission;
  recentlyReviewedList: IProduct[] = [];

  // ─── Constructor ─────────────────────────────────────────────────────────────
  constructor(
    private productService: ProductsService,
    private router: Router,
    public authService: AuthService,
    private signalrService: SignalrService,
  ) {}

  // ─── Lifecycle Hooks ────────────────────────────────────────────────────────
  ngOnInit(): void {
    if (!this.authService.hasPermission(Permission.PostAssetsStatus)) {
      return;
    }

    this.getRecentlyReviewed();

    SignalrGroup.join({
      signalrService: this.signalrService,
      destroyRef: this.destroyRef,
      group: SignalRStaticGroups.ProductsReviewed,
      data$: this.signalrService.productsReviewedData,
      onData: (data: ProductSearch) => {
        this.recentlyReviewedList = updateRecentlyList(this.recentlyReviewedList, data);
      },
    });
  }

  ngOnDestroy(): void {
    this.signalrService.clearProductsReviewed();
  }

  // ─── Data Fetching Methods ──────────────────────────────────────────────────
  getRecentlyReviewed(): void {
    this.productService
      .searchByCode(
        undefined,
        undefined,
        7,
        undefined,
        undefined,
        'RecentlyApprovedExternalEnhancement',
      )
      .subscribe((res) => {
        this.recentlyReviewedList = res.results;
      });
  }

  // ─── Action Methods ─────────────────────────────────────────────────────────
  viewMore(filter: string): void {
    this.router.navigateByUrl(`product-filter?key=${filter}`);
  }
}
